import script from "./ExporeMore.vue?vue&type=script&setup=true&lang=tsx"
export * from "./ExporeMore.vue?vue&type=script&setup=true&lang=tsx"

import "./ExporeMore.vue?vue&type=style&index=0&id=6ebe2b02&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ebe2b02"]])

export default __exports__